<fieldset class="flex justify-between w-full">
  <legend class="contents font-normal text-md">
    {{ label }}
  </legend>

  <mat-radio-group
    [formControl]="control"
    class="flex"
    aria-label="Select an option">
    @for (option of options; track option.value) {
      <mat-radio-button
        (focus)="onFocus.emit($event)"
        (blur)="onBlur.emit($event)"
        [value]="option.value"
        >{{ option.label }}</mat-radio-button
      >
    }
  </mat-radio-group>
</fieldset>
